import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class BreadcrumbService {
    public cambioConfiguracionRuta$: Observable<void>;
    private nombresAmigableRutas: Map<string, string> = new Map<string, string>();
    private nombresAmigableRutasRegex: Map<string, string> = new Map<string, string>();
    private callbackRutas: Map<string, (url: string) => string> = new Map<string, (url: string) => string>();
    private callbackRutasRegex: Map<string, (url: string) => string> = new Map<string, (url: string) => string>();
    private esconderRutas: any = new Array<string>();
    private esconderRutasRegex: any = new Array<string>();
    private _cambioConfiguracionRuta$ = new Subject<void>();

    constructor() {
        this.cambioConfiguracionRuta$ = this._cambioConfiguracionRuta$.asObservable();
    }

    /**
     * Agrega un nombre amigable a la ruta.
     *
     * @param ruta Ruta a asociar con el nombre
     * @param nombre Nombre amigable de la ruta
     */
    public agregarNombreAmigableARuta(ruta: string, nombre: string): void {
        this.nombresAmigableRutas.set(ruta, nombre);
        this._cambioConfiguracionRuta$.next();
    }

    /**
     * Agrega un nombre amigable a la ruta que cumpla con el regex.
     *
     * @param rutaRegex Regex para la ruta
     * @param nombre Nombre amigable de la ruta
     */
    public agregarNombreAmigableARutaRegex(rutaRegex: string, nombre: string): void {
        this.nombresAmigableRutasRegex.set(rutaRegex, nombre);
        this._cambioConfiguracionRuta$.next();
    }

    /**
     * Agrega un callback cuando la ruta coincide.
     *
     * @param ruta Ruta a asociar
     * @param callback Callback a llamar
     */
    public agregarCallbackARuta(ruta: string, callback: (id: string) => string): void {
        this.callbackRutas.set(ruta, callback);
        this._cambioConfiguracionRuta$.next();
    }

    /**
     * Agrega un callback cuando el regex de la ruta coincide.
     *
     * @param rutaRegex Ruta regex a asociar
     * @param callback Callback a llamar
     */
    public agregarCallbackARutaRegex(rutaRegex: string, callback: (id: string) => string): void {
        this.callbackRutasRegex.set(rutaRegex, callback);
        this._cambioConfiguracionRuta$.next();
    }

    /**
     * Obtener nombre amigable para la ruta. Si no existe se muestra '/'
     *
     * @param ruta Ruta de la cual obtener nombre amigable
     */
    public obtenerNombreAmigable(ruta: string): string {
        const routeEnd = ruta.substr(ruta.lastIndexOf("/") + 1, ruta.length);
        let name: string = routeEnd;

        this.nombresAmigableRutas.forEach((value, key) => {
            if (key === ruta) {
                name = value;
            }
        });

        this.nombresAmigableRutasRegex.forEach((value, key) => {
            if (new RegExp(key).exec(ruta)) {
                name = value;
            }
        });

        this.callbackRutas.forEach((value, key) => {
            if (key === ruta) {
                name = value(routeEnd);
            }
        });

        this.callbackRutasRegex.forEach((value, key) => {
            if (new RegExp(key).exec(ruta)) {
                name = value(routeEnd);
            }
        });

        return name;
    }

    /**
     * Esconder ruta del breadcrumb
     *
     * @param ruta Ruta a esconder
     */
    public esconderRuta(ruta: string): void {
        if (this.esconderRutas.indexOf(ruta) === -1) {
            this.esconderRutas.push(ruta);
            this._cambioConfiguracionRuta$.next();
        }
    }

    /**
     * Esconder ruta que coincide con el regex del breadcrumb
     *
     * @param rutaRegex Ruta regex a esconder
     */
    public esconderRutaRegex(rutaRegex: string): void {
        if (this.esconderRutasRegex.indexOf(rutaRegex) === -1) {
            this.esconderRutasRegex.push(rutaRegex);
            this._cambioConfiguracionRuta$.next();
        }
    }

    /**
     * Devuelve si la ruta tiene que ocultarse
     *
     * @param ruta Ruta a esconder
     */
    public debeEsconder(ruta: string): boolean {
        let hide = this.esconderRutas.indexOf(ruta) > -1;

        this.esconderRutasRegex.forEach((value: any) => {
            if (new RegExp(value).exec(ruta)) {
                hide = true;
            }
        });

        return hide;
    }
}
